import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader } from '../loader';
import { ProfitAndLossContext } from '../../pages';
import { ReportFlowStep, USERS_TYPES_STYLES } from '../../constants';
import { VIEWS_MAP } from '../../../../router/constants';

export const Report = () => {
  const location = useLocation();
  const { t } = useTranslation('reportsEN');
  const FlowContext = useContext(ProfitAndLossContext);
  const [prevPathName, setPrevPathName] = useState<string>('');
  const [shouldResetSteps, setShouldResetSteps] = useState<boolean>(false);

  const context = useContext(ProfitAndLossContext);

  useEffect(() => {
    setPrevPathName(location.pathname);
    setShouldResetSteps(true);
  }, []);

  useEffect(() => {
    if (location.pathname !== prevPathName && shouldResetSteps) {
      FlowContext?.setActiveStep(ReportFlowStep.INTRO);
    }
  }, [location.pathname]);
  const reportData = (() => {
    switch (location.pathname.replace('/', '')) {
      case VIEWS_MAP.STATEMENT_OF_CASH_FLOWS:
        return {
          title: t('REPORTS.TITLE.CASH_FLOW'),
          iFrameUrl: context?.IframeUrlCashFlow,
        };
      case VIEWS_MAP.PROFIT_AND_LOSS:
        return {
          title: t('REPORTS.TITLE.PROFIT_AND_LOSS'),
          iFrameUrl: context?.iframeUrlProfitAndLoss,
        };
      case VIEWS_MAP.EXPENSES:
        return {
          title: t('REPORTS.TITLE.EXPENSES'),
          iFrameUrl: context?.iframeUrlExpenses,
        };
      default:
        return {
          title: '',
          iFrameUrl: '',
        };
    }
  })();

  const activeComponent = useCallback(() => {
    if (context?.isLoading) {
      return <Loader />;
    }
    return (
      <iframe
        data-testid='reportIframe'
        id='report'
        className={USERS_TYPES_STYLES.IFRAME}
        title={reportData.title}
        src={reportData.iFrameUrl}
      />
    );
  }, [context?.isLoading, context?.iframeUrlProfitAndLoss, context?.IframeUrlCashFlow, context?.iframeUrlExpenses]);

  return <div className={USERS_TYPES_STYLES.IFRAME_WRAPPER}>{activeComponent()}</div>;
};
